export const scrollToError = (errorClass = 'is_error', highlightClass = 'highlight-error', duration = 2000) => {
  // Fehler-Elemente suchen
  const errorElements = document.getElementsByClassName(errorClass);
  if (errorElements.length > 0) {
    const firstError = errorElements[0];

    // Scrollen zum ersten Fehler
    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Hervorhebung des Fehlers
    if (highlightClass) {
      firstError.classList.add(highlightClass);
      setTimeout(() => firstError.classList.remove(highlightClass), duration);
    }
  }
};
